import { getCookie } from '../utils/cookie';

import request, { apiURL } from '../utils/api';
class WriteOffService {
  writeOff(customerId: string, propertyId: string, orgId: string) {
    const options = {
      method: 'POST',
      headers: {
        Authorization: getCookie('session_id'),
        'Content-Type': 'application/json',
      },
    };
    return request(
      `${apiURL}/${orgId}/${propertyId}/customers/${customerId}/write-off`,
      options,
    );
  }
}

export default WriteOffService;
